import { initialSOState, ISOState } from '../state/so.state';
import { SOAction, ESOActions } from '../actions/so.action';



export function soReducers(state = initialSOState, action: SOAction): ISOState {
    switch (action.type) {

        case ESOActions.GetAllSODetails: {
            // console.log(action.payload)
            return {
                ...state,
                getAllSODetails: action.payload,
                // getSOErrorMessage: null
            };
        }

        case ESOActions.GetSOCodeSuccess: {
            return {
                ...state,
                getSOCodeSuccess: action.payload,
                // getSOErrorMessage: null
            };
        }
       
        case ESOActions.GetSOByIdSuccess: {
            return {
                ...state,
                getSOByIdSuccess: action.payload,
                getSOByIdError: null
            };
        }

        case ESOActions.GetSOByIdError: {
            return {
                ...state,
                getSOByIdError: action.payload,
                getSOByIdSuccess: null
            };
        }

        case ESOActions.SetSOSuccess: {
            const success = {
                data : action.payload,
                from : action.from
            }
            return {
                ...state,
                getSOSuccessMessage: success,
                // getSOErrorMessage: null
            };
        }
        case ESOActions.SetSOError: {
            const error = {
                data : action.payload,
                from : action.from
            }
            return {
                ...state,
                getSOErrorMessage: error,
                // getSOSuccessMessage: null,
                // getAllSODetails: null
            };
        }
        case ESOActions.GetInActiveStatusSuccess: {
            return {
                ...state,
                getInactiveSOSuccess:action.payload,
                getInactiveSOError :null
            };
        }
        case ESOActions.GetInActiveStatusError: {
            return {
                ...state,
                getInactiveSOError:action.payload,
                getInactiveSOSuccess :null
            };
        }
        case ESOActions.GetCloseSOSuccess: {
            return {
                ...state,
                getCloseSOSuccess:action.payload,
                getCloseSOError :null
            };
        }
        case ESOActions.GetCloseSOError: {
            return {
                ...state,
                getCloseSOError:action.payload,
                getCloseSOSuccess :null
            };
        }

        case ESOActions.GetForcastSalesSuccess: {
            return {
                ...state,
                getForcastSalesSuccess:action.payload,
                getForcastSalesError :null
            };
        }
        case ESOActions.GetForcastSalesError: {
            return {
                ...state,
                getForcastSalesError:action.payload,
                getForcastSalesSuccess :null
            };
        }
        case ESOActions.GetaddForcastSalesSuccess: {
            return {
                ...state,
                getaddForcastSalesSuccess:action.payload,
                getaddForcastSalesError :null
            };
        }
        case ESOActions.GetaddForcastSalesError: {
            return {
                ...state,
                getaddForcastSalesError:action.payload,
                getaddForcastSalesSuccess :null
            };
        }
        case ESOActions.GeteditForcastSalesSuccess: {
            return {
                ...state,
                geteditForcastSalesSuccess:action.payload,
                geteditForcastSalesError :null
            };
        }
        case ESOActions.GeteditForcastSalesError: {
            return {
                ...state,
                geteditForcastSalesError:action.payload,
                geteditForcastSalesSuccess :null
            };
        }
        //dispatch orders
        case ESOActions.GetDONumberSuccess: {
            return {
                ...state,
                getDONumberSuccess:action.payload,
                getDONumberError :null
            };
        }
        case ESOActions.GetDONumberError: {
            return {
                ...state,
                getDONumberError:action.payload,
                getDONumberSuccess :null
            };
        }
        case ESOActions.GetAddDOSuccess: {
            return {
                ...state,
                addDOSuccess:action.payload,
                addDOError :null
            };
        }
        case ESOActions.GetAddDOError: {
            return {
                ...state,
                addDOError:action.payload,
                addDOSuccess :null
            };
        }
        case ESOActions.GetAllDOsSuccess: {
            return {
                ...state,
            getAllDOSuccess:action.payload,
            getAllDOError :null
            };
        }
        case ESOActions.GetAllDOsError: {
            return {
                ...state,
           getAllDOError:action.payload,
           getAllDOSuccess :null
            };
        }
        case ESOActions.GetDOsByPSSuccess: {
            return {
                ...state,
            getDOsByPSSuccess:action.payload,
            getDOsByPSError :null
            };
        }
        case ESOActions.GetDOsByPSError: {
            return {
                ...state,
           getDOsByPSError:action.payload,
           getDOsByPSSuccess :null
            };
        }
        case ESOActions.GetDOdetailsSuccess: {
            return {
                ...state,
         getDOdetailsSuccess :action.payload,
         getDOdetailsError :null
            };
        }
        case ESOActions.GetDOdetailsError: {
            return {
                ...state,
         getDOdetailsError :action.payload,
         getDOdetailsSuccess :null
            };
        }
        case ESOActions.GetAddPackSlipsSuccess: {
            return {
                ...state,
         getAddPackslipsSuccess :action.payload,
         getAddPackSlipsError :null
            };
        }
        case ESOActions.GetAddPackSlipsError: {
            return {
                ...state,
         getAddPackSlipsError :action.payload,
         getAddPackslipsSuccess :null
            };
        }
        case ESOActions.GetAllPackSlipsSuccess: {
            return {
                ...state,
        getAllPackSlipsSuccess :action.payload,
        getAllPackSlipsError :null
            };
        }
        case ESOActions.GetAllPackSlipsError: {
            return {
                ...state,
         getAllPackSlipsError :action.payload,
         getAllPackSlipsSuccess  :null
            };
        }
        case ESOActions.GetEditpackSlipsSuccess: {
            return {
                ...state,
        getEditPackSlipsSuccess:action.payload,
        getEditPackSlipsError:null
            };
        }
        case ESOActions.GetEditpackSlipsError: {
            return {
                ...state,
        getEditPackSlipsError:action.payload,
        getEditPackSlipsSuccess:null
            };
        }
        case ESOActions.GetRPsBasedOnMonthSuccess: {
            return {
                ...state,
            getRpsBasedOnMonthSuccess:action.payload,
            getRpsBasedOnMonthError:null
            };
        }
        
        case ESOActions.GetRPsBasedOnMonthError: {
            return {
                ...state,
                getRpsBasedOnMonthError:action.payload,
                getRpsBasedOnMonthSuccess:null
            };
        }
        case ESOActions.GetDosByFormulaIdSuccess: {
            console.log(action)
            return {
                ...state,
            getDosByFormulaIdSuccess:action.payload,
            getDosByFormulaIdError:null
            };
        }
        
        case ESOActions.GetDosByFormulaIdError: {
            return {
                ...state,
                getDosByFormulaIdError:action.payload,
                getDosByFormulaIdSuccess:null
            };
        }
        case ESOActions.InActivatePsSuccess: {
            console.log(action)
            return {
                ...state,
            inActivatePsSuccess:action.payload,
            inActivatePsError:null
            };
        }
        
        case ESOActions.InActivatePsError: {
            return {
                ...state,
                inActivatePsError:action.payload,
                inActivatePsSuccess:null
            };
        }
        case ESOActions.GetSOsByCustomerIdSuccess: {
            console.log(action)
            return {
                ...state,
            getSOsByCustomerIdSuccess:action.payload,
            getSOsByCustomerIdError:null
            };
        }
        case ESOActions.GetSOsByCustomerIdError: {
            console.log(action)
            return {
                ...state,
            getSOsByCustomerIdSuccess:null,
            getSOsByCustomerIdError:action.payload
            };
        }
        case ESOActions.cancelDoSuccess: {
            console.log(action)
            return {
                ...state,
            cancelDoSucces:action.payload,
            cancelDoError:null
            };
        }
        case ESOActions.cancelDoError: {
            console.log(action)
            return {
                ...state,
            cancelDoSucces:null,
            cancelDoError:action.payload
            };
        }
        default: {   
            return state;
          }
    }

}